import SegmentedControl from '../../../../components/SegmentedControl'
import React, { useState } from 'react'
import { SellOrderContext } from '../../../../providers/SellOrdersProvider'
import { Body, Header, OrdersContainer } from '../../styles'
import ForConfirmOrderItem from './ForConfirmOrderItem'

function ForConfirmOrders() {
  const { porConfirmar, porRevision, fetch, vendorsArray: vendors, vendorsIdArray: vendorIds } = React.useContext(SellOrderContext);
  const [mode, setMode] = useState('confirm');
  const orders = mode === 'review' ? porRevision : porConfirmar;
  React.useEffect(() => {
    if (porRevision.length === 0) setMode('confirm');
  }, [porRevision.length]);
  const [selectedVendor, setSelectedVendor] = useState('all');

  const filterOrders = React.useMemo(() => {
    if (selectedVendor === 'all') {
      return orders;
    } else if (selectedVendor === 'oficina') {
      return orders.filter(order => !vendorIds.includes(order.user.id))
    } else {
      return orders.filter(order => order.user.id === selectedVendor)
    }
  }, [selectedVendor, orders, vendorIds])


  const handleSelectVendor = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedVendor(e.target.value);
  }

  return (
    <OrdersContainer>
      <Header style={{ flexWrap: 'wrap', gap: '0.5rem' }}>
        <div style={{ flex: '0 1 auto', maxWidth: '100%' }}>
          <SegmentedControl items={[
            { key: 'confirm', label: 'Por confirmar', count: porConfirmar.length },
            ...(porRevision.length > 0 ? [{ key: 'review', label: 'Por revisión', count: porRevision.length }] : [])
          ]} activeKey={mode} onChange={setMode} />
        </div>
        <select aria-label="Filtrar por vendedor" style={{ minWidth: 0, maxWidth: '100%' }} name="vendors" id="vendors" value={selectedVendor} onChange={handleSelectVendor}>
          <option value="all">Todos</option>
          <option value="oficina">Oficina</option>
          {vendors.map(v => (
            <option key={v.value} value={v.value}>{v.label}</option>
          ))}
        </select>
      </Header>
      <Body>
        {filterOrders.length === 0 && <h3>{mode === 'review' ? 'No hay ventas por revisión' : 'No hay ventas por confirmar'}</h3>}
        {filterOrders.map((o) => (
          <ForConfirmOrderItem
            key={o.id}
            order={o}
            refresh={fetch}
          />
        ))}
      </Body>
    </OrdersContainer>
  )
}

export default ForConfirmOrders